import { AxiosResponse } from "axios";
import { AssociatedBodyShopResponse, SupplierRegistrationCheckResponse } from "@/main/models/response/supplierResponse";
import { Result } from "@/main/models/common/resultResponse";
import { api } from "../base/api";
import { ISupplierApi } from "../base/registration/supplierApi";
import { KeyValue } from "../../models/common";
import {
	SupplierFilterRequest,
	SupplierSaveRequest,
	SupplierRegistrationCheckRequest,
	SaveSupplierCompanyRelationRequest,
	SaveSupplierConfigurationRequest,
	SaveSupplierCompanyBuyerRequest,
	SupplierFavoriteRequest,
	ChangeSupplierRelationInfoRequest,
} from "../../models/request/supplierRequest";
import {
	SupplierRegistrationDataResponse,
	SupplierResponse,
	SupplierAssignBodyshopResponse,
} from "../../models/response";
import { SupplierCompanyRelationFilterRequest } from "@/main/models/request/supplierCompanyRelationRequest";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { SupplierCompanyRelationResponse } from "@/main/models/response/supplierCompanyRelationResponse";
import { PartTypeSupplierIgnoreResponse } from "@/main/models/response/partTypeSupplierIgnoreResponse";
import { PartTypeSupplierIgnoreRequest } from "@/main/models/request/partTypeSupplierIgnoreRequest";

const baseRoute: string = "Supplier";

export class SupplierApi extends ISupplierApi {
	getFavoriteSuppliersByCompanyBuyer(
		request: SupplierFavoriteRequest,
	): Promise<AxiosResponse<PaginationResponse<KeyValue[]>>> {
		return api.get(`${baseRoute}/getfavoritesuppliersbycompanybuyer`, {
			params: request,
		});
	}
	getSearchGrid(request: SupplierFilterRequest): Promise<AxiosResponse<SupplierResponse>> {
		return api.get(`${baseRoute}`, { params: request });
	}

	getSuppliersOrSupplierBranchesDomain(request: SupplierFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}

	saveSupplier(request: SupplierSaveRequest): Promise<AxiosResponse<Result<any>, any>> {
		return api.post(`${baseRoute}`, request);
	}

	checkRegistrationDuplicates(
		request: SupplierRegistrationCheckRequest,
	): Promise<AxiosResponse<Result<SupplierRegistrationCheckResponse>>> {
		return api.post(`${baseRoute}/checkregistrationduplicates`, request);
	}

	getAssociatedBodyShops(guidSupplier: string): Promise<AxiosResponse<Result<AssociatedBodyShopResponse[]>>> {
		return api.get(`${baseRoute}/getassociatedbodyshops`, { params: { guidSupplier } });
	}

	getSupplierData(request: SupplierFilterRequest): Promise<AxiosResponse<Result<SupplierRegistrationDataResponse>>> {
		return api.get(`${baseRoute}/getsupplierdata`, { params: request });
	}

	getGridRestrictedAndFavorite(
		request: SupplierFilterRequest,
	): Promise<AxiosResponse<PaginationResponse<SupplierRegistrationDataResponse>>> {
		return api.get(`${baseRoute}/getgridrestrictedandfavorite`, {
			params: request,
		});
	}

	getSupplierRestrictedAndFavorite(
		request: SupplierCompanyRelationFilterRequest,
	): Promise<AxiosResponse<PaginationResponse<SupplierCompanyRelationResponse>>> {
		return api.get(`${baseRoute}/getsupplierrestrictedandfavorite`, {
			params: request,
		});
	}

	saveSupplierCompanyRelation(request: SaveSupplierCompanyRelationRequest): Promise<AxiosResponse<Result<any>, any>> {
		return api.post(`${baseRoute}/savesuppliercompanyrelation`, request);
	}

	saveSupplierConfiguration(request: SaveSupplierConfigurationRequest): Promise<AxiosResponse<Result<void>>> {
		return api.post(`${baseRoute}/saveSupplierConfiguration`, request);
	}

	getBodyshopByRFC(
		RegistrationNumber: string,
		guidCountry: string,
	): Promise<AxiosResponse<Result<SupplierAssignBodyshopResponse[]>>> {
		return api.get(`${baseRoute}/getbodyshopbyrfc`, {
			params: { guidCountry, RegistrationNumber },
		});
	}

	saveSupplierCompanyBuyer(request: SaveSupplierCompanyBuyerRequest): Promise<AxiosResponse<Result<any>, any>> {
		return api.post(`${baseRoute}/savesuppliercompanybuyer`, request);
	}

	getFavoriteSuppliersByQuoteItem(guidQuoteItem: string): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/getfavoritesuppliersbyquoteitem`, {
			params: { guidQuoteItem },
		});
	}

	changeSupplierRelationInfo(
		guidSupplierCompanyRelation: string,
		request: ChangeSupplierRelationInfoRequest,
	): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.post(`${baseRoute}/ChangeSupplierRelationInfo`, request, {
			params: { guidSupplierCompanyRelation },
		});
	}

	getPartTypeSupplierIgnore(
		request: PartTypeSupplierIgnoreRequest,
	): Promise<AxiosResponse<Result<PartTypeSupplierIgnoreResponse[]>>> {
		return api.post(`${baseRoute}/GetPartTypeSupplierIgnore`, request);
	}
}
